export const Icones = {
    adicaoAmarelo: '/assets/icones/AdicaoAmarelo.svg',
    adicaoCinza: '/assets/icones/Adicaocinza.svg',
    arquivoAmarelo: '/assets/icones/ArquivoAmarelo.svg',
    arquivoCinza: '/assets/icones/ArquivoCinza.svg',
    arquivoMovimentoAmarelo: '/assets/icones/ArquivoMovimentoAmarelo.svg',
    arquivoMovimentoCinza: '/assets/icones/ArquivoMovimentoCinza.svg',
    calendarioAmarelo: '/assets/icones/CalendarioAmarelo.svg',
    calendarioCinza: '/assets/icones/CalendarioCinza.svg',
    carteiraAmarelo: '/assets/icones/CarteiraAmarelo.svg',
    carteiraCinza: '/assets/icones/CarteiraCinza.svg',
    casaAmarelo: '/assets/icones/CasaAmarelo.svg',
    corretoAmarelo: '/assets/icones/CorretoAmarelo.svg',
    corretoCinza: '/assets/icones/CorretoCinza.svg',
    dialogoAmarelo: '/assets/icones/DialogoAmarelo.svg',
    dialogoCinza: '/assets/icones/DialogoCinza.svg',
    envelopeAmarelo: '/assets/icones/EnvelopeAmarelo.svg',
    envelopeCinza: '/assets/icones/EnvelopeCinza.svg',
    filtroAmarelo: '/assets/icones/FiltroAmarelo.svg',
    filtroCinza: '/assets/icones/Filtrocinza.svg',
    listaAmarelo: '/assets/icones/ListaAmarelo.svg',
    listaCinza: '/assets/icones/ListaCinza.svg',
    listaTopicoAmarelo: '/assets/icones/ListaTopicoAmarelo.svg',
    listaTopicoCinza: '/assets/icones/ListaTopicoCinza.svg',
    livroAmarelo: '/assets/icones/LivroAmarelo.svg',
    livroCinza: '/assets/icones/LivroCinza.svg',
    pranchetaAmarelo: '/assets/icones/PranchetaAmarelo.svg',
    pranchetaCinza: '/assets/icones/PranchetaCinza.svg',
    usuarioAmarelo: '/assets/icones/UsuarioAmarelo.svg',
    usuarioCinza: '/assets/icones/UsuarioCinza.svg',
    usuariosAmarelo: '/assets/icones/UsuariosAmarelo.svg',
    usuariosCinza: '/assets/icones/UsuariosCinza.svg',
    valorMoedaAmarelo: '/assets/icones/ValorMoedaAmarelo.svg',
    valorMoedaCinza: '/assets/icones/ValorMoedaCinza.svg',
    valorNotaAmarelo: '/assets/icones/ValorNotaAmarelo.svg',
    valorNotaCinza: '/assets/icones/ValorNotaCinza.svg',
    seta: '/assets/icons/seta.svg',
};